<template>
  <div class="grid">
    <div class="col-12 p-pt-1">
        <TabMenu :model="items" />
      </div>
  </div>
</template>
<script>
export default {
  name: 'DNSNavBar',
  data () {
    return {
      items: [],
    }
  },
  computed: {
    isLoggedIn: function () { return this.$store.state.auth.status.loggedIn }
  },
  mounted() {
    this.items = [
                //{
                //    label: 'Dashboard',
                //    icon: 'pi pi-fw pi-home',
                //    to: '/',
                //    visible: () => this.isLoggedIn
                //},
                //{
                //    label: 'Domains',
                //    icon: 'pi pi-fw pi-calendar',
                //    to: '/domains',
                //    visible: () => this.isLoggedIn
                //},
                 {
                    label: 'Records',
                    icon: 'pi pi-fw pi-calendar',
                    to: '/domains/' + this.$route.params.domain_id + '/dns/records',
                },
                {
                    label: 'Settings',
                    icon: 'pi pi-fw pi-cog',
                    to: '/domains/' + this.$route.params.domain_id + '/dns/settings',

                },
    ]
  },
}
</script>
<style>

</style>
